export default "__VITE_ASSET__DVvC375p__"